import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { User } from '@domain/models';

@Component({
  selector: 'app-contact-list',
  imports: [CommonModule],
  templateUrl: './contact-list.component.html',
  styleUrl: './contact-list.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactListComponent {
  contacts = input<User[]>([]);
  disabled = input(false);
  selectContact = output<string>();

  onSelect(id: string): void {
    if (this.disabled()) return;
    this.selectContact.emit(id);
  }
}
